import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { HOST } from '../../utils/env'
import getBannerToRender from './getBannerToRender'
import PlayerPlusBanner from './banners/PlayerPlusBanner'
import cookies from '../../utils/cookies'
import SimplePlayerBanner from './banners/SimplePlayerBanner'

const Banner = () => {
  const [newsletterStatusChecked, setNewsletterStatusChecked] = useState(false)
  const [isVip, setIsVip] = useState(true)
  // data held in state separately to avoid undefined issues with other fields
  const [data, setData] = useState({})
  const [bannerType, setBannerType] = useState('')
  const [imageView, setImageView] = useState(false)
  // retrive the data from the store using reacthooks useSelector
  const users = useSelector(stateSelector => stateSelector.user)

  useEffect(() => {
    // only check the status if we have a userID
    if (!users.userId) return
    setIsVip(cookies.get('STV_VIP_OPTIN') === 'true')
    setNewsletterStatusChecked(true)
  }, [users.userId])

  useEffect(() => {
    setBannerType(getBannerToRender({
      isLoggedIn: users.isLoggedIn,
      isVip,
      currentlySubscribed: users.currentlySubscribed,
    }))
  }, [users.isLoggedIn, isVip])

  useEffect(() => {
    if (!bannerType) return
    fetchData()
  }, [bannerType])

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  const handleWindowResize = () => {
    if (window.innerWidth >= 1024) {
      setImageView(false)
    } else {
      setImageView(true)
    }
  }

  const fetchData = async () => {
    const url = bannerType === 'playerVip' ? `https://strapi.cms.${HOST}/api/promo-banners?populate=deep&filters[guid]=player-vip` : `https://strapi.cms.${HOST}/api/promo-banners?populate=deep&filters[guid]=player-plus`
    // fetch article
    try {
      await fetch(url)
        .then(response => response.json())
        .then((result) => {
          if (result && result.data) {
            setData(result?.data[0]?.attributes)
          }
          return null
        })
    } catch {
      return null
    }
    return null
  }

  // we don't want to render any banner until we've checked both the user's subscription status
  // AND whether they're subscribed, or confirmed they're not logged in.
  // This stops banners flickering in and out as the state updates
  // eslint-disable-next-line max-len
  const shouldRenderBanner = ((users.loginChecked && newsletterStatusChecked) || (users.loginChecked && !users.userId))

  if (!shouldRenderBanner) return null

  if (!data) return null

  if (data?.useBasicBanner) return <SimplePlayerBanner bannerData={data} imageView={imageView} />

  switch (bannerType) {
    case 'playerPlus':
      // eslint-disable-next-line max-len
      return <PlayerPlusBanner usedTrial={users.usedTrial} bannerData={data} imageView={imageView} />

    default:
      return null
  }
}

Banner.defaultProps = {
  users: {
    currentlySubscribed: false,
    usedTrial: false,
    isLoggedIn: false,
    userId: null,
    loginChecked: false,
    targetedAdvertising: false,
  },
}

export default Banner
